
import React, { useState, useEffect, lazy, useContext, useMemo } from "react";
import { getToken as getRecaptchaToken } from "../../../recaptcha";
import { Button, Table, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Constant from "../../../constants";
import { useAuth } from "../../../Providers/AuthProvider";
import { axiosInstance } from "../../../Api";
import { fetchApplicationTypeApi, isSmallScreenDevice, getPermitFee } from "../../Utility";
import "./slider.css";
import CaasImgSlider from "./CaasImgSlider";
import SliderMenu from "./SliderMenu";
import DeviceSizeModal from "../DeviceSizeModal";
import { CommonDataContext } from "../../../App";
import LoadingSkeletonBox from "../LoadingSkeletonBox";
import { Suspense } from "react";
const Loader = lazy(async () => await import("../../Loader"));


export default function Slider(props) {
    const context = useContext(CommonDataContext);
    const { commonInItData: propData } = props;
    const commonInItData = propData ?? context?.commonInItData;

    const [focusedIdx, setFocusedIdx] = useState("0");
    const [slideingNo, setSlidingNo] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [showDeviceSizeAlert, setShowDeviceSizeAlert] = useState(false);
    const navigate = useNavigate();
    const { user } = useAuth();



    //const [paymentInItData, setPaymentInItData] = useState(null);

    const onlineEnquiry = (e, id, title) => {
        navigate("/checkPermitEligibility", {
            state: { applicationType: id, activityType: title },
        });
    }

    useEffect(() => {
        // MOVED THIS loadPaymentInItData() TO App.js
        //loadPaymentInItData();

        window.scrollTo(0, 0);
    }, []);

    // useEffect(() => {
    //     if (user?.status) {
    //         if (user.status === "PENDING_REGISTRATION") {
    //             navigate("/profile");
    //         } else if (user.status === "SUBMITTED") {
    //             navigate("/userStatus");
    //         } else if (user.status === "ACTIVE") {
    //             console.log("------ YES Dashboard ------");
    //             navigate("/dashboard");
    //         } else if (
    //             user.status === "DISABLED" ||
    //             user.status === "DELETED" ||
    //             user.status === "REJECTED"
    //         ) {
    //             navigate("/userStatus");
    //         }
    //     } else {
    //         navigate("/home");
    //     }
    // }, [navigate, user]);

    const fetchData = async (url, id, header, subTitle, aerialActivityDesc) => {

        setShowLoader(true);
        try {
            const recaptchaToken = await getRecaptchaToken();
            const { data: response } = await axiosInstance(recaptchaToken).get(url);

            navigate("/apply/permit", {
                state: {
                    newDetail: response, id: id, header: header, subTitle: subTitle, fresh: true
                    , aerialActivityDesc: aerialActivityDesc
                },
            });
        } catch (error) {
            console.error(error);
        }
        finally {
            setShowLoader(false);
        }
    };


    const openApply = async (event, id, header, subTitle, aerialActivityDesc) => {


        event.preventDefault();
        setShowLoader(true);
        const url = fetchApplicationTypeApi(id);
        const uflag = user?.status === "ACTIVE";

        if (uflag) {

            const flag = isSmallScreenDevice();
            if (flag) {
                setShowDeviceSizeAlert(true);
                setShowLoader(false);
            }
            else {
                setShowDeviceSizeAlert(false);

                await fetchData(url, id, header, subTitle, aerialActivityDesc);

            }


        } else if (user?.status === "PENDING_REGISTRATION") {
            navigate("/profile");
        } else if ((user?.status === "SUBMITTED" || user?.status === "DELETED" || user?.status === "DISABLED" || user?.status === "REJECTED")) {
            navigate("/userStatus");
        }
        else {
            setShowLoader(false);
            navigate("/login");
        }


    };

    const tabClick = (id) => {
        setSlidingNo(id);
        setFocusedIdx(id);
    }

    const getPermitFeeMemoized = useMemo(
        () => (appType, appSubType) => getPermitFee(commonInItData?.permitFeeList, appType, appSubType),
        [commonInItData?.permitFeeList]
    );

    const renderContent = (id = "0", openWindow) => {
        switch (id) {
            case "0":
                return (<AerialActivities openApply={openWindow} enquiry={onlineEnquiry} getFee={getPermitFeeMemoized} />)
            case "1":
                return (<AerialPhotoGraphy openApply={openWindow} enquiry={onlineEnquiry} getFee={getPermitFeeMemoized} />)
            case "2":
                return (<Crane openApply={openWindow} enquiry={onlineEnquiry} getFee={getPermitFeeMemoized} />)
            case "3":
                return (<ShipCrossing openApply={openWindow} enquiry={onlineEnquiry} getFee={getPermitFeeMemoized} />)
            default:
                return null;
        }
    }

    return (
        <>
            {showDeviceSizeAlert ?
                <DeviceSizeModal show={showDeviceSizeAlert} setShow={(flag) => setShowDeviceSizeAlert(flag)} showOnMapLoad={false} /> : null
            }

            <section className="slider" id="slider" >
                <div className="container">
                    <section aria-label="Slider Section with Application Types" className="slider-container">
                        <Suspense fallback={<LoadingSkeletonBox height="600px" />}>
                            <CaasImgSlider sliderNumber={slideingNo} slidingClk={(id) => setFocusedIdx(id)} />
                        </Suspense>
                        {/* <Suspense fallback={<LoadingSkeletonBox height="74px" />}> */}
                        <SliderMenu activeTab={tabClick} />
                        {/* </Suspense> */}
                    </section>

                    <Loader show={showLoader} onHide={() => setShowLoader(false)} />
                    <section className="slide-tab-content">
                        {renderContent(focusedIdx, openApply)}
                    </section>

                </div>
            </section>



            {/* <Suspense fallback={<LoadingSkeletonBox height="100vh" />}>
                <section className="slider" id="slider" >
                    <div className="container">
                        <section aria-label="Slider Section with Application Types" className="slider-container">
                            <CaasImgSlider sliderNumber={slideingNo} slidingClk={(id) => setFocusedIdx(id)} />
                            <SliderMenu activeTab={tabClick} />
                        </section>

                        <Loader show={showLoader} onHide={() => setShowLoader(false)} />
                        <section className="slide-tab-content">
                            {renderContent(focusedIdx, openApply)}
                        </section>

                    </div>
                </section>
            </Suspense> */}
        </>
    );
}

const AerialPhotoGraphy = (props) => {
    const { openApply, getFee } = props
    const blimpAirshipPermitFee = getFee(1, 'Blimp / Airship');
    const captiveBalloonPermitFee = getFee(1, 'Captive Balloon');
    const helicopterPermitFee = getFee(1, 'Helicopter');

    return (
        <>
            <div className="marginTop-30 marginBot-30" data-aos="fade-up">
                <div className="form-wrapper tab-content-wrap">
                    <h1>Clearance for Conduct of Aerial Mapping / Photography / Videography</h1>
                    <hr />
                    <h2>When to apply?</h2>
                    <article>
                        Aerial photography involves capturing images, including moving images, from an aircraft or other airborne platforms. Applicant will need to apply for clearance from CAAS through SkySafe if you are conducting the activity using the following platforms in Singapore:
                        <ul>
                            <li>
                                Helicopters
                            </li>
                            <li>
                                Fixed Wing Aircraft
                            </li>
                        </ul>
                    </article>

                    {(blimpAirshipPermitFee > 0 || captiveBalloonPermitFee > 0 || helicopterPermitFee > 0) && (<>
                        <h3>Fees</h3>
                        <p>
                            A non-refundable processing fee is payable online using major credit/debit cards such as Visa or MasterCard.
                        </p>

                        <Container className="mb-2">
                            <Row xs="auto">
                                <Col md={4} >
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Type of Aircraft / Platform</th>
                                                <th>Fee</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Blimp / Airship</td>
                                                <td>{`S$${blimpAirshipPermitFee}`}</td>
                                            </tr>
                                            <tr>
                                                <td>Captive Balloon</td>
                                                <td>{`S$${captiveBalloonPermitFee}`}</td>
                                            </tr>
                                            <tr>
                                                <td>Helicopter</td>
                                                <td>{`S$${helicopterPermitFee}`}</td>
                                            </tr>
                                        </tbody>
                                    </Table>

                                </Col>

                            </Row>

                        </Container>
                    </>)}

                    <h3>Information Required for Application</h3>
                    <p className="mb-2">
                        How to apply?
                    </p>
                    <ul className="list-style">
                        <li>
                            To access SkySafe, Singpass/Corppass login is required. Foreign users without Singpass will need to register for a SkySafe account and upload an Identification Document for verification. The uploaded Identification Document will be removed from the system after the verification process.
                        </li>
                        <li>
                            The application will take approximately 10 mins to complete. Please ensure you have the following information ready prior to making an application:
                            <ul>
                                <li>Location details (Applicant will need to draw the activity location on the map)</li>
                                {(blimpAirshipPermitFee > 0 || captiveBalloonPermitFee > 0 || helicopterPermitFee > 0) && (<>
                                    <li>
                                        Credit/Debit Card for Fee payment
                                    </li>
                                </>)}
                            </ul>
                        </li>
                    </ul>
                    <Button
                        variant="primary"
                        className="btn btn-primary sgds btn-gap btn-caas btn-primary-caas"
                        onClick={(e) => openApply(e, Constant.card[0].id, Constant.card[0].header)}
                    >
                        Apply
                    </Button>

                </div>
            </div>
        </>)
}

const Crane = (props) => {
    const { openApply, getFee } = props
    const cranePermitFee = getFee(2, null);

    return (
        <div className="marginTop-30 marginBot-30" data-aos="fade-up">
            <div className="form-wrapper tab-content-wrap">
                <h1>Clearance for Erection of Cranes and Tall Construction Machinery</h1>
                <hr />
                <h2>When to apply?</h2>
                <p>
                    In the development of buildings, the erection of tall construction machinery, such as cranes and tall construction machinery, have the potential to impact the safety of air navigation, either by being situated in close proximity to aircraft operating areas or by posing as an obstruction along a flight path. The need for clearance from CAAS depends on the equipment's location and its height. To assess if a clearance from CAAS is required, applicant can utilise the Enquiry Tool.
                </p>
                {cranePermitFee > 0 && (<>
                    <h3>Fees</h3>
                    <p>

                        A <b>{`S$${cranePermitFee}`}</b> non-refundable processing fee is payable online using major credit/debit cards such as Visa or MasterCard.
                    </p>
                </>)}
                <h3>Information Required for Application</h3>
                <p className="mb-2">
                    How to apply?
                </p>
                <ul className="list-style">
                    <li>
                        To access SkySafe, Singpass/Corppass login is required. Foreign users without Singpass will need to register for a SkySafe account and upload an Identification Document for verification. The uploaded Identification Document will be removed from the system after the verification process.
                    </li>
                    <li>
                        The application will take approximately 10 mins to complete. Please ensure you have the following information ready prior to making an application:
                        <ul>
                            <li>Location details (Applicant will need to draw the activity location on the map); and</li>
                            <li>Name and contact number of safety personnel on site.</li>
                            {cranePermitFee > 0 && (<>
                                <li>
                                    Credit/Debit Card for Fee payment
                                </li>
                            </>)}
                        </ul>
                    </li>
                </ul>
                <Button
                    variant="primary"
                    className="btn btn-primary sgds btn-gap btn-caas btn-primary-caas"
                    onClick={(e) => openApply(e, Constant.card[1].id, Constant.card[1].header)}
                >
                    Apply
                </Button>
            </div>
        </div>
    )
}

const ShipCrossing = (props) => {
    const { openApply, getFee } = props
    const shipCrossingPermitFee = getFee(3, null);

    return (
        <div className="marginTop-30 marginBot-30" data-aos="fade-up">
            <div className="form-wrapper tab-content-wrap">
                <h1>Clearance for Ship Crossing</h1>
                <hr />
                <h2>When to apply?</h2>
                <p>
                    The operation of ship crossings has the potential to impact the safety of air navigation, either due to the close proximity between the ship and an overflying aircraft, or the vessel posing as an obstruction along the flight path which may impact operations at the airport. To ensure air navigation safety, shipping agents or vessel operators may need to obtain prior clearance from CAAS before sailing the shipping lanes to the North and South of Changi Airport. Clearance is needed when vessels, height 50m and above, transit the East Johore Strait. In addition, all vessels with a height 100m and above and operating south of Changi Airport (please refer to Maritime Port Authority Port Marine Circular 88 of 97) are required to obtain CAAS' clearance prior to the transit.
                </p>
                {shipCrossingPermitFee > 0 && (<>
                    <h3>Fees</h3>
                    <p>
                        A <b>{`S$${shipCrossingPermitFee}`}</b> non-refundable processing fee is payable online using major credit/debit cards such as Visa or MasterCard.
                    </p>
                </>)}
                <h3>Information Required for Application</h3>
                <p className="mb-2">
                    How to apply?
                </p>
                <ul className="list-style">
                    <li>
                        To access SkySafe, Singpass/Corppass login is required. Foreign users without Singpass will need to register for a SkySafe account and upload an Identification Document for verification. The uploaded Identification Document will be removed from the system after the verification process.
                    </li>
                    <li>
                        The application will take approximately 10 mins to complete.
                    </li>
                </ul>
                <Button
                    variant="primary"
                    className="btn btn-primary sgds btn-gap btn-caas btn-primary-caas"
                    onClick={(e) => openApply(e, Constant.card[2].id, Constant.card[2].header)}
                    aria-label="Apply for Clearance for Ship Crossing"
                >
                    Apply
                </Button>
            </div>
        </div>
    )
}

const AerialActivities = (props) => {
    const { openApply, enquiry, getFee } = props
    const fees = getFee(4, 'BRELEASE');

    return (
        <Suspense fallback={<LoadingSkeletonBox height={"500px"} />}>
            <div className="marginTop-30 marginBot-30" >
                {/* data-aos="fade-up10" */}
                <div className="form-wrapper tab-content-wrap">
                    <h1>Permit for Aerial Activities</h1>
                    <hr />
                    <h2>When to apply?</h2>
                    <p>
                        In Singapore, there is a growing popularity of aerial activities, including the flying of kites or releasing of balloons. When conducted near airports or airbases, these activities can pose a significant distraction to pilots, particularly during aircraft take-off and landing. The need for a permit depends on the location of the activity, its operating height and the size of the object. To assess if a permit from CAAS is required, applicant can utilise the Enquiry Tool.
                    </p>

                    {fees > 0 && (<>
                        <h3>Fees</h3>
                        <p>
                            A non-refundable processing fee given for each activity below, is payable online using major credit/debit cards such as Visa or MasterCard.
                        </p>
                    </>)}

                    <h3>Information Required for Application</h3>
                    <p className="mb-2">
                        How to apply?
                    </p>
                    <ul className="list-style">
                        <li>
                            To access SkySafe, Singpass/Corppass login is required. Foreign users without Singpass will need to register for a SkySafe account and upload an Identification Document for verification. The uploaded Identification Document will be removed from the system after the verification process.
                        </li>
                        <li>
                            The application will take approximately 10 mins to complete. Please ensure you have the following information ready prior to making an application:
                            <ul>
                                <li>Location details to draw on the map; and</li>
                                <li>Name and contact number of safety personnel on site.</li>
                                {fees > 0 && (<>
                                    <li>
                                        Credit/Debit Card for Fee payment
                                    </li>
                                </>)}
                            </ul>
                        </li>
                    </ul>
                    <h3>Type of Aerial Activities</h3>


                    {Object.values(Constant.activityTypesWithId).map((activity) => (

                        <AaCard key={activity.id}
                            title={activity.cardTitle}
                            description={activity.cardDesc}
                            imgSrc={process.env.PUBLIC_URL + activity.imgSrc}
                            openApply={openApply} enquiry={enquiry} fees={fees}
                            actityTypeNumber={activity.activityNumber} aerialActivityDesc={activity.label} />
                    ))}

                    <div data-aos="fade-up" className="mt-4">
                        <h3>Location of Activities</h3>
                        <p>Some aerial activities require a notification to CAAS or a permit from CAAS.</p>
                        <p>Please refer to the below map, which marks out the area limits for aerial activities. For specific area and height limits for each aerial activity, please visit the individual aerial activity webpage.</p>
                        <p>For more information on the permit requirements for the different types of activities, please refer to the relevant sections below.
                            For any queries, please contact us at:</p>
                        <p>Email: <a href={`mailto:${Constant.SKYSAFE_SUPPORT_EMAIL}`}>{Constant.SKYSAFE_SUPPORT_EMAIL}</a></p>
                    </div>
                </div>
            </div>
        </Suspense>
    )
}

const AaCard = (props) => {
    const { title, description, imgSrc, openApply, enquiry, fees, actityTypeNumber, aerialActivityDesc } = props;

    return (
        <div className="col-12 mt-3 mb-3">
            <div className="card" data-aos="fade-up">
                <div className="card-horizontal">
                    <div className="img-square-wrapper">
                        <img className={"img-responsive"} src={imgSrc} alt="" width={400} height={250}
                            loading="eager" decoding="auto" fetchpriority="high" />
                    </div>
                    <div className="card-body">
                        <h4 className="card-title">{title}</h4>
                        <p className="card-text">
                            {description}
                        </p>

                        <AerialAcitityFeesAndButtons inputs={{
                            fees: fees,
                            openApply: openApply,
                            enquiry: enquiry, actityTypeNumber: actityTypeNumber,
                            aerialActivityDesc: aerialActivityDesc,
                            title: title
                        }} />

                    </div>
                </div>
            </div>
        </div>

    )
};


const AerialAcitityFeesAndButtons = (props) => {
    const { openApply, fees, actityTypeNumber, aerialActivityDesc, title } = props.inputs;

    return (
        <>
            {fees > 0 && (<>
                <div className="card-body-fees-div">
                    <b>Fees:</b> {`S$${fees}`} &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
            </>)}
            <div className="card-body-buttons-div">

                {/* <Button
                    variant="primary"
                    className="btn btn-primary sgds btn-gap btn-caas btn-primary-caas min-width-100px"
                    onClick={(e) => enquiry(e, Constant.card[3].id, Constant.activityTypes[actityTypeNumber].id)}
                >
                    Enquiry Tool
                </Button> */}
                <Button
                    variant="primary"
                    className="btn btn-primary sgds btn-gap btn-caas btn-primary-caas min-width-100px"
                    onClick={(e) => openApply(e, Constant.card[3].id, Constant.card[3].header,
                        Constant.activityTypes[actityTypeNumber].id, aerialActivityDesc)}
                    aria-label={`Apply for ${title}`}
                >
                    Apply
                </Button>
            </div>
        </>
    );
}